<!-- <p>First Slide</p> -->
<div class="row">
    <div class="col-xl-12">
        <!-- <div class="form-group float-left m-2">
            <input class="form-control" type="search" [ngStyle]="{'max-width.px': 250}" placeholder="search here"
                (search)="searchData($event)" (keyup)="searchData($event)">
        </div> -->
        <div class="form-group  float-right m-2">
            <div ngbDropdown class="d-inline-block float-right m-2">
                <button class="btn btn-secondary" id="dropdownBasic1" ngbDropdownToggle><i
                        class="fa fa-list fa-lg"></i></button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1" style="padding: 5px;">
                    <label>Select Columns</label>
                    <ul>
                        <li *ngFor="let column of tableColumns">
                            <input [name]="column.name" type="checkbox" [(ngModel)]="column.displayColumn"> &nbsp;&nbsp;
                            <label [for]="column.name">{{column.name}}</label>
                        </li>
                    </ul>
                </div>
            </div>
            <button class="btn btn-secondary btn-tall float-right m-2" style="margin-bottom: 5px;"
                [ngStyle]="{float:'right'}" (click)="toggleFilters=!toggleFilters">Filter</button>
        </div>
    </div>
    <!-- Filter stuffs -->
    <div class="filterRow">
        <div *ngIf="toggleFilters" class="row">
            <div class="filterColumn filterCard">
                <div class="card-body">
                    <label>Location</label>
                    <div>
                        <label>State</label>

                        <!-- <ng-multiselect-dropdown [placeholder]="'Select States'" [settings]="dropdownSettings"
                            [data]="dropdownListStates" [value]="selectedState" [(ngModel)]="selectedState"
                            (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)" ngDefaultControl
                            id="state" name="state">
                        </ng-multiselect-dropdown> -->
                    </div>
                    <div>
                        <label>District</label>

                        <!-- <ng-multiselect-dropdown [placeholder]="'Select Districts'" [settings]="dropdownSettings"
                            [data]="dropdownListDistricts" [value]="selectedDistrict" [(ngModel)]="selectedDistrict"
                            (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)" ngDefaultControl
                            name="district" id="district">
                        </ng-multiselect-dropdown> -->
                    </div>
                    <div>
                        <label>Circle</label>

                        <!-- <ng-multiselect-dropdown [placeholder]="'Select Circle'" [settings]="dropdownSettings"
                            [data]="dropdownListCircles" [(ngModel)]="selectedCircle" (onSelect)="onItemSelect($event)"
                            (onSelectAll)="onSelectAll($event)" ngDefaultControl name="selectedCircle">
                        </ng-multiselect-dropdown> -->
                    </div>
                </div>
            </div>

            <div class="filterColumn">
                <div class="filterCard">
                    <div class="card-body">
                        <label>Billing Type</label>
                        <br>
                        <ul>
                            <li><input type="checkbox"><label>&nbsp;&nbsp;PBE</label> </li>
                            <li><input type="checkbox"><label>&nbsp;&nbsp;EBE</label></li>
                            <li><input type="checkbox"><label>&nbsp;&nbsp;NBE</label> </li>
                        </ul>
                    </div>
                    <div class="card-body">
                        <label><span class='headernomove'>Equipment Category</span></label>

                        <!-- <ng-multiselect-dropdown [placeholder]="'Select Equipment Number'" [settings]="dropdownSettings"
                            [data]="dropdownListEquipments" [(ngModel)]="selectedEquipment"
                            (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)" ngDefaultControl
                            name="selectedEquipment">
                        </ng-multiselect-dropdown> -->
                    </div>

                </div>
            </div>

            <div class='filterColumn3 filterCard'>
                <div class="card-body">
                    <label>Date Range</label>
                    <br>
                    <div class='tableDataRange'>
                        <table cellspacing="0" cellpadding="0">
                            <tr>
                                <td><input type="checkbox"><label>&nbsp;&nbsp;Installation Dates</label>
                                </td>
                                <td><input type="checkbox"><label>&nbsp;&nbsp;Rental Start Date</label></td>
                            </tr>
                            <tr>
                                <td><input type="checkbox"><label>&nbsp;&nbsp;T&C Dates </label></td>
                                <td><input type="checkbox"><label>&nbsp;&nbsp;Rental End Date</label></td>
                            </tr>
                            <tr>
                                <td><input type="checkbox"><label>&nbsp;&nbsp;Acceptance Date </label></td>
                                <td><input type="checkbox"><label>&nbsp;&nbsp;Warranty Start Date</label>
                                </td>
                            </tr>
                            <tr>
                                <td><input type="checkbox"><label>&nbsp;&nbsp;Purchase Date</label></td>
                                <td><input type="checkbox"><label>&nbsp;&nbsp;Warranty End Date </label>
                                </td>
                            </tr>
                        </table>

                    </div>
                    <div class='tableDataRange'>
                        <table>
                            <tr>
                                <td><input type="date" class="form-control" id="DateFrom" (change)="DateFromHandler()"
                                        (click)="curDatePicker()" [max]="this.curDate" name="DateFrom"
                                        onkeydown="return false" [(ngModel)]="this.dateFrom" required /></td>
                                <td><label>&nbsp;From date</label></td>
                            </tr>
                            <br>
                            <tr>
                                <td><input type="date" class="form-control" id="DateTo" (click)="curDatePicker()"
                                        [min]="this.dateFrom" [max]="this.curDate" name="DateTo"
                                        onkeydown="return false" [(ngModel)]="this.dateTo" required /></td>
                                <td><label>&nbsp;To Date</label></td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class='filterColumn4 filterCard'>
                <div class="card-body tableDataRange">
                    <label>Conditional Status</label>
                    <br>
                    <table>
                        <tr>
                            <td><input type="checkbox"><label>&nbsp;&nbsp;Active</label></td>
                            <td><input type="checkbox"><label>&nbsp;&nbsp;Inactive</label></td>
                            <td><input type="checkbox"><label>&nbsp;&nbsp;BER</label></td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="col-xl-12">
                <div class="row">
                    <div class="col-md-3"></div>
                    <div class="col-md-3"></div>

                    <div class="col-md-3">
                        <button type="button" class="btn btn-secondary">Apply</button>

                    </div>

                    <div class="col-md-3" style="margin-bottom: 10px;">
                        <button type="button" class="btn btn-danger">Cancel</button>


                    </div>
                </div>
            </div>
        </div>

        <br>
        <div class="col-xl-12 table-responsive">
            <table class="table table-hover table-fixed" >
                <thead>
                    <tr>
                        <th *ngFor="let column of tableColumns"
                            (click)="sortByDataKey(column.dataKey, column.sortDirection)"
                            [hidden]="!column.displayColumn">
                            {{column.name}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <!-- <tr *ngFor="let data of tableDatas | slice: (page-1) * pageSize : page * pageSize">
                        <td *ngFor="let column of tableColumns" [hidden]="!column.displayColumn">
                            
                            {{data[column.dataKey]}}
                        </td>
                        
                    </tr> -->
                    <tr *ngFor = 'let data of assetTypes | slice: (page-1) * pageSize : page * pageSize'>
                        <td >{{data.name}}</td>
                        <td >{{data.date}}</td>
                        <td >{{ data.added }}</td>
                        <td >{{data.removed}}</td>
                        <td >{{data.endDate}}</td>
                    </tr>
                </tbody>
            </table>
        </div>


        <div class="col-xl-12">
            Showing {{(pageSize * page) - pageSize + 1}} to {{page === totalPageSize || tableDatas.length !=
            tableDatasOriginal.length ? tableDatas.length : pageSize *
            page}} of {{tableDatasOriginal.length}}
            <ngb-pagination class="d-flex justify-content-end" [pageSize]="pageSize"
                [collectionSize]="tableDatas.length" [(page)]="page" [maxSize]="5" [rotate]="true"
                [ellipses]="false" [boundaryLinks]="true"></ngb-pagination>
        </div>
    </div>

   
</div>